import dayjs from 'dayjs'

export const yearsSinceDate = (date?: string): string => {
  return Math.round(dayjs().diff(date, 'years')).toString()
}